<template>
  <div class="navbar-content" :class="{ 'hide-nav': !isActive, 'open-nav': isActive }">
    <i @click="openNav" :class="['arrow', { active: isActive }]" class="arrow fa-solid fa-chevron-right"></i>
    <nav :class="{ 'hide-nav': !isActive, 'open-nav': isActive }">
      <ul>
        <li>
          <router-link to="/" class="logo">
            <img @contextmenu.prevent src="../assets/icon_logo1.png" alt="logo" style="caret-color: transparent;">
            <div class="holder">
              <span class="nav-item">FTC</span>
            </div>
          </router-link>
        </li>
        <li @click="toggleMenu('')" v-if='$checkPermission("layout")'><router-link to="/management-details/layout-adjustments">
            <i class="fas fa-solid fa-desktop"></i>
            <span class="nav-item">Giao diện trang</span>
        </router-link></li>
        <li @click="toggleMenu('')" v-if='$checkPermission("view_menus")'><router-link to="/management-details/menus">
            <i class="fas fa-solid fa-bars"></i>
            <span class="nav-item">Menus</span>
        </router-link></li>
        <li @click="toggleMenu('')" v-if='$checkPermission("view_submenus")'><router-link to="/management-details/sub-menus">
            <i class="fas fa-solid fa-bars-staggered"></i>
            <span class="nav-item">Menus phụ</span>
        </router-link></li>
        <li @click="toggleMenu('')" v-if='$checkPermission("view_qnas")'><router-link to="/management-details/questions">
            <i class="fas fa-solid fa-clipboard-question"></i>
            <span class="nav-item">Hỏi đáp</span>
        </router-link></li>
        <li @click="toggleMenu('')" v-if='$checkPermission("view_contact")'><router-link to="/management-details/contact">
            <i class="fas fa-solid fa-phone-volume"></i>
            <span class="nav-item">Liên hệ</span>
        </router-link></li>
        <li @click="toggleMenu('news')" v-if='$checkPermission("view_regularNews") || $checkPermission("view_mainNews")
         || $checkPermission("view_dynamicNews")'>
          <router-link to="/management-details/news-config" :class="{ toggleActive: menuVisibility.news }" @click.prevent>
            <i class="fas fa-solid fa-newspaper"></i>
            <span class="nav-item">Mục tin tức</span>
          </router-link>
          <ul v-show="menuVisibility.news" style="background: rgb(0 151 191)">
            <li id="sub-li" v-if='$checkPermission("view_regularNews")'><router-link to="/management-details/news-config/regular-news" @click.stop>
              <i class="fas fa-solid fa-newspaper"></i>
              <span class="nav-item">Tin thường xuyên</span>
            </router-link></li>

            <li id="sub-li" v-if='$checkPermission("view_mainNews")'><router-link to="/management-details/news-config/main-news" @click.stop>
              <i class="fas fa-solid fa-newspaper"></i>
              <span class="nav-item">Tin chính</span>
            </router-link></li>

            <li id="sub-li" v-if='$checkPermission("view_dynamicNews")'><router-link to="/management-details/news-config/dynamic-news" @click.stop>
              <i class="fas fa-solid fa-newspaper"></i>
              <span class="nav-item">Tin động</span>
            </router-link></li>

            <li id="sub-li" v-if='$checkPermission("view_dynamicNews")'><router-link to="/management-details/news-config/customer-news" @click.stop>
              <i class="fas fa-solid fa-newspaper"></i>
              <span class="nav-item">Tin khách hàng</span>
            </router-link></li>
          </ul>
        </li>
        <li @click="toggleMenu('')" v-if='$checkPermission("view_tservices")'><router-link to="/management-details/training-services">
            <i class="fas fa-solid fa-book-open"></i>
            <span class="nav-item">Dịch vụ huấn luyện</span>
        </router-link></li>
        <li @click="toggleMenu('')" v-if='$checkPermission("view_tserdetails")'><router-link to="/management-details/training-service-details">
            <i class="fas fa-solid fa-circle-info"></i>
            <span class="nav-item">Dịch vụ con </span>
        </router-link></li>
        <!-- <li><router-link to="/management-details/news">
            <i class="fas fa-solid fa-newspaper"></i>
            <span class="nav-item">News</span>
        </router-link></li> -->
        <li @click="toggleMenu('')" v-if='$checkPermission("view_admissions")'><router-link to="/management-details/admissions">
            <i class="fas fa-solid fa-graduation-cap"></i>
            <span class="nav-item">Tuyển sinh</span>
        </router-link></li>
        <li @click="toggleMenu('')" v-if='$checkPermission("view_application")'><router-link to="/management-details/applications">
            <i class="fas fa-solid fa-clipboard-user"></i>
            <span class="nav-item">Phiếu đăng ký tuyển sinh</span>
        </router-link></li>
        <li @click="toggleMenu('')" v-if='$checkPermission("view_subscription")'><router-link to="/management-details/subscriptions">
            <i class="fas fa-solid fa-file-circle-exclamation"></i>
            <span class="nav-item">Thông tin Subscription</span>
        </router-link></li>
        <li @click="toggleMenu('document')" v-if='$checkPermission("view_documents")'>
          <router-link to="/management-details/document-config" :class="{ toggleActive: menuVisibility.document }" @click.prevent>
            <i class="fas fa-solid fa-file-invoice"></i>
            <span class="nav-item">Mục tài liệu</span>
          </router-link>
          <ul v-show="menuVisibility.document" style="background: rgb(0 151 191)" v-if='$checkPermission("view_documentCAT")'>
            <li id="sub-li"><router-link to="/management-details/document-config/document-categories" @click.stop>
              <i class="fas fa-solid fa-layer-group"></i>
              <span class="nav-item">Danh mục tài liệu</span>
            </router-link></li>

            <li id="sub-li" v-if='$checkPermission("view_documents")'><router-link to="/management-details/document-config/documents" @click.stop>
              <i class="fas fa-solid fa-file-lines"></i>
              <span class="nav-item">Tài liệu</span>
            </router-link></li>
          </ul>
        </li>
        <li @click="toggleMenu('')" v-if='$checkPermission("view_tschedules")'><router-link to="/management-details/training-schedules">
            <i class="fas fa-solid fa-calendar-day"></i>
            <span class="nav-item">Lịch huấn luyện</span>
        </router-link></li>
        <li @click="toggleMenu('')" v-if='$checkPermission("view_tshdetails")'><router-link to="/management-details/training-schedules-details">
            <i class="fas fa-solid fa-calendar-days"></i>
            <span class="nav-item">Nội dung lịch huấn luyện</span>
        </router-link></li>
        <li @click="toggleMenu('media')" v-if='$checkPermission("view_mediaCAT")'>
          <router-link to="/management-details/media-config" :class="{ toggleActive: menuVisibility.media }" @click.prevent>
            <i class="fas fa-solid fa-panorama"></i>
            <span class="nav-item">Mục media</span>
          </router-link>
          <ul v-show="menuVisibility.media" style="background: rgb(0 151 191)" v-if='$checkPermission("view_mediaCAT")'>
            <li id="sub-li"><router-link to="/management-details/media-config/media-categories" @click.stop>
              <i class="fas fa-solid fa-layer-group"></i>
              <span class="nav-item">Danh mục media</span>
            </router-link></li>

            <li id="sub-li" v-if='$checkPermission("view_media")'><router-link to="/management-details/media-config/media" @click.stop>
              <i class="fas fa-solid fa-photo-film"></i>
              <span class="nav-item">Media</span>
            </router-link></li>
          </ul>
        </li>
        <li @click="toggleMenu('')" v-if='$checkPermission("view_footer")'><router-link to="/management-details/footer">
            <i class="fas fa-solid fa-arrows-down-to-line"></i>
            <span class="nav-item">Chân trang</span>
        </router-link></li>
        <li @click="toggleMenu('user')">
          <router-link to="/management-details/user-config" :class="{ toggleActive: menuVisibility.user }" @click.prevent>
            <i class="fas fa-solid fa-user-pen"></i>
            <span class="nav-item">Mục người dùng</span>
          </router-link>
          <ul v-show="menuVisibility.user" style="background: rgb(0 151 191)">
            <li id="sub-li"><router-link to="/management-details/user-config/account" @click.stop>
              <i class="fas fa-solid fa-user"></i>
              <span class="nav-item">Tài khoản</span>
            </router-link></li>

            <li id="sub-li" v-if='$checkPermission("view_user")'><router-link to="/management-details/user-config/users-management" @click.stop>
              <i class="fas fa-solid fa-user-plus"></i>
              <span class="nav-item">Người dùng</span>
            </router-link></li>

            <li id="sub-li" v-if='$checkPermission("view_roles")'><router-link to="/management-details/user-config/roles-management" @click.stop>
              <i class="fas fa-solid fa-user-tag"></i>
              <span class="nav-item">Vai trò</span>
            </router-link></li>

            <li id="sub-li" v-if='$checkPermission("view_permissions")'><router-link to="/management-details/user-config/permissions-management" @click.stop>
              <i class="fas fa-solid fa-user-shield"></i>
              <span class="nav-item">Quyền hạn</span>
            </router-link></li>

            <li id="sub-li" v-if='$checkPermission("config_user-role")'><router-link to="/management-details/user-config/group-management" @click.stop>
              <i class="fas fa-solid fa-users-rectangle"></i>
              <span class="nav-item">Phân chia vai trò</span>
            </router-link></li>

            <li id="sub-li" v-if='$checkPermission("config_group-permission")'><router-link to="/management-details/user-config/authorize-management" @click.stop>
              <i class="fas fa-solid fa-users-gear"></i>
              <span class="nav-item">Phân chia quyền hạn</span>
            </router-link></li>
          </ul>
        </li>
        <li @click.prevent="logOut"><router-link to="/login">
            <i class="fas fa-solid fa-arrow-right-from-bracket"></i>
            <span class="nav-item">Đăng xuất</span>
        </router-link></li>
        <!-- <li class="logout" @click.prevent="logOut"><router-link to="/login">
            <i class="fas fa-solid fa-arrow-right-from-bracket"></i>
            <span class="nav-item">Log out</span>
        </router-link></li> -->
      </ul>
    </nav>
  </div>

</template>
<script>
import axios from 'axios'
export default {

  data () {
    return {
      isActive: false,
      menuVisibility: {
        news: false,
        document: false,
        user: false,
        media: false
      }
    }
  },
  methods: {
    openNav () {
      this.isActive = !this.isActive
    },
    async logOut () {
      await this.$store.dispatch('users/logout')
      this.$store.state.isLoggedIn = false
      // this.$store.state.authAxios = null
      this.$store.state.userId = 0
      this.$store.state.userRoles = []
      this.$store.state.userPermissions = []
      this.$store.state.userPermissionNames = []
      this.$store.state.username = ''
      this.$store.state.email = ''
      this.$store.state.token = null
      delete axios.defaults.headers.common.Authorization
      this.$store.dispatch('initializeAxios', null)
      localStorage.removeItem('storeLocal')
      this.$router.push('/login')
    },
    toggleMenu (menu) {
      // Toggle visibility of the clicked menu by directly accessing the object property
      // this.menuVisibility[menu] = !this.menuVisibility[menu]
      Object.keys(this.menuVisibility).forEach(key => {
        if (key !== menu) {
          this.menuVisibility[key] = false // Close all other menus
        }
      })

      // Toggle the clicked menu
      this.menuVisibility[menu] = !this.menuVisibility[menu]
    }
  }
}
</script>
<style scoped>
  .navbar-content {
    position: relative;
    min-height: 100vh;
  }

  nav {
    /* position: absolute; */
    top: 0;
    bottom: 0;
    height: 100%;
    left: 0;
    background: #006884;
    overflow: hidden;
    box-shadow: 0 20px 35px rgba(0, 0, 0, 0.1);
    z-index: 2;
  }

  .logo {
    text-align: center;
    display: flex;
    margin: 10px 0 0 14px;
  }

  .logo div {
    position: relative;
  }

  .logo span {
    position: absolute;
    font-weight: bold;
    padding-left: 12px;
    font-size: 18px;
    text-transform: uppercase;
    top: 7px;
  }

  .logo:hover {
    background: none;
  }

  li {
    padding: 5px;
  }

  #sub-li {
    padding-left: 0px;
  }

  a {
    position: relative;
    color: #fff;
    font-size: 14px;
    display: table;
    text-decoration: none;
    border-radius: 12px;
  }

  a.toggleActive {
    border-end-end-radius: 0px;
    border-end-start-radius: 0px;
  }

.fas {
  position: relative;
  width: 70px;
  height: 40px;
  top: 11px;
  font-size: 20px;
  text-align: center;
}

.nav-item {
  position: relative;
  top: 9px;
  margin-left: 10px;
}

  a:hover {
    background: rgba(207, 149, 49, 0.7);
  }

  .logout {
    position: absolute;
    bottom: 0;
  }

  .arrow {
    position: absolute;
    width: 22px;
    height: 22px;
    line-height: 22px;
    right: -12px;
    font-size: 12px;
    background: #fff;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.7);
    text-align: center;
    font-weight: bold;
    top: 18px;
    border-radius: 50px;
    color: #006884;
    transition: all 0.3s ease;
    z-index: 3;
    cursor: pointer;
    caret-color: transparent;
  }

  .arrow.active {
    transform: rotate(180deg);
  }

  .hide-nav {
    transition: all 0.3s ease;
    width: 80px;
  }

  .hide-nav ul li a span{
    display: none;
  }

  .open-nav {
    transition: all 0.3s ease;
    width: 280px;
  }

  .open-nav ul li a span{
    display: initial;
  }

  .open-nav ul li a{
    width: 270px;
  }

  nav a.router-link-active {
    background: rgba(207, 149, 49, 0.9);
  }

  nav ul li ul li a:hover {
    background: rgba(207, 149, 49, 0.7) !important;
  }

  nav ul li ul li a.router-link-active {
    color: #F9BA10;
    background: transparent;
  }
</style>
